import { lang } from "./i18n/i18n";

/** « 1 paragraphe modifié », « 3 paragraphes modifiés » : nombre et nom accordés, au lieu de « paragraphe(s)
 *  modifié(s) ». Le singulier vaut pour 0 et 1 en français, pour 1 seulement en anglais ; les formes arrivent
 *  traduites (`plural(n, t("incident"), t("incidents"))`). */
export function plural(count: number, one: string, many: string): string {
  const singular = lang() === "en" ? count === 1 : count <= 1;
  return `${count} ${singular ? one : many}`;
}
